module.exports = new __parcel__URL__("logo_long_croped.6f26171b.png").toString();